module.exports = __webpack_public_path__ + "media/images/Package System Combination/header25-5c14c58176c48f1c669cb020f4457974.png";